import React from "react";

function ShareButton() {
  const handleShare = async () => {
    const shareData = {
      title: "VidMantra",
      text: "Check this out!",
      url: window.location.href,
    };

    try {
      // Mobile / Supported Browser Native Share
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        // Fallback copy link
        await navigator.clipboard.writeText(window.location.href);
        alert("Link copied to clipboard!");
      }
    } catch (error) {
      console.log("Share cancelled or failed", error);
    }
  };

  return (
 
  <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="share-nodes"
                  className="w-5 h-5"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path
                    fill="currentColor"
                    d="M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
                  />
                </svg>
    
  );
}

export default ShareButton;